import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_GTM_ID,
};

if (tagManagerArgs?.gtmId) {
    TagManager.initialize(tagManagerArgs);
}

import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/app.scss";

const root = createRoot(document.getElementById("root"));

root.render(<App />);
